import { Paths } from '../../../lib/constants/path'
import { RoleEnum } from '../../../lib/types/enums/users/role.enum'
import { Route } from '../../../lib/types/routes'
import { InsuranceCreatePage } from './insurance-create'
import { InsuranceListPage } from './insurance-list'
import { InsuranceUpdatePage } from './insurance-update'

export const insuranceRoutes: Route[] = [
  {
    path: Paths.INSURANCE_LIST_PAGE,
    roles: [RoleEnum.ADMIN],
    element: <InsuranceListPage />
  },
  {
    path: Paths.INSURANCE_CREATE_PAGE,
    roles: [RoleEnum.ADMIN],
    element: <InsuranceCreatePage />
  },
  {
    path: Paths.INSURANCE_UPDATE_PAGE,
    roles: [RoleEnum.ADMIN],
    element: <InsuranceUpdatePage />
  }
]
